import { css } from 'lit';

export const timeredCounterNumberStyles = css``;
